import React, {useState} from 'react';
import './index.css'
import {useDispatch, useSelector} from 'react-redux';
import ChatAppSetting from "../../pages/Home/Chat/setting";
import {message, Modal} from "antd";
import {setLeftIndex} from "../../store/modules/user";
//新建语境组件
const CreateChatApp =(props)=>{
    const {addParam,originalScenario,setHomePageIndex} = props
    const {size} = useSelector(state=>state.fontSizeChange)
    const dispatch = useDispatch()
    const [isChatOpen,setIsChatOpen] = useState(false)
	const answerThree = {
		fontSize:size==='小'?'12px':(size==='中'?'14px':'16px'),
        margin:'50px 0',
        color:localStorage.getItem('ai-chat-theme')==='default'?'#666':'#999'
	}
    const handleChangeIndex = (i)=>{
        dispatch(setLeftIndex(i.toString()))
        setTimeout(()=>{
            setHomePageIndex(4)
        },500)
    }
    const handleChatOpen = ()=>{
        setIsChatOpen(true)
    }
    const handleChatAppOk = ()=>{
        handleChangeIndex('0')
        setIsChatOpen(false)
    }
    const handleCloseChatApp = ()=>{
        setIsChatOpen(false)
    }
    return (
        <>
        <div className="createChat" style={answerThree}>
            想要继续讨论? 请点击: <span onClick={handleChatOpen}>创建语境</span>
        </div>
            <Modal footer={null} destroyOnClose={true} title="语境设置(新建)" open={isChatOpen} onCancel={handleCloseChatApp} width={360}>
                <ChatAppSetting isAdd={true} handleOk={handleChatAppOk} handleCloseModel={handleCloseChatApp} addParam={addParam} originalScenario={originalScenario}/>
            </Modal>
        </>
    )
}
export default CreateChatApp
